import { Container, Typography, Box } from '@mui/material'

export default function CheckoutPage() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Checkout
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          This page will handle the checkout process for both registered and guest users.
        </Typography>
      </Box>
    </Container>
  )
}